export function getCookie(cname) {
  const name = `${cname}=`;
  const decodedCookie = decodeURIComponent(document.cookie);
  const ca = decodedCookie.split(';');
  for (let i = 0; i < ca.length; i += 1) {
    let c = ca[i];
    while (c.charAt(0) === ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

const STORAGE_COOKIE_PREFIX = 'ac_storage_';
const ONE_YEAR_IN_SECONDS = 60 * 60 * 24 * 365;

function setStorageCookie(key, value) {
  const encodedKey = `${STORAGE_COOKIE_PREFIX}${encodeURIComponent(key)}`;
  const encodedValue = encodeURIComponent(value);
  const secureFlag = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${encodedKey}=${encodedValue};path=/;max-age=${ONE_YEAR_IN_SECONDS};SameSite=Lax${secureFlag}`;
}

function getStorageCookie(key) {
  return getCookie(`${STORAGE_COOKIE_PREFIX}${encodeURIComponent(key)}`);
}

function removeStorageCookie(key) {
  const secureFlag = window.location.protocol === 'https:' ? ';Secure' : '';
  document.cookie = `${STORAGE_COOKIE_PREFIX}${encodeURIComponent(
    key
  )}=;path=/;max-age=0;SameSite=Lax${secureFlag}`;
}

function clearStorageCookies() {
  const cookies = document.cookie.split(';');
  cookies.forEach((cookie) => {
    const trimmedCookie = cookie.trim();
    if (trimmedCookie.startsWith(STORAGE_COOKIE_PREFIX)) {
      const cookieKey = trimmedCookie.split('=')[0].replace(
        STORAGE_COOKIE_PREFIX,
        ''
      );
      removeStorageCookie(decodeURIComponent(cookieKey));
    }
  });
}

class Storage {
  constructor() {
    this.syncPromise = null;
  }

  static setItem(key, value) {
    try {
      localStorage.setItem(key, value);
    } catch (error) {
      // Ignore write errors (e.g. storage disabled)
    }
    try {
      setStorageCookie(key, value);
    } catch (error) {
      // Ignore write errors (e.g. cookies disabled)
    }
    return value;
  }

  static getItem(key) {
    try {
      const storedValue = localStorage.getItem(key);
      if (storedValue) {
        try {
          setStorageCookie(key, storedValue);
        } catch (error) {
          // Ignore write errors
        }
        return storedValue;
      }
    } catch (error) {
      // Ignore read errors
    }

    const cookieValue = getStorageCookie(key);
    if (cookieValue) {
      try {
        localStorage.setItem(key, cookieValue);
      } catch (error) {
        // Ignore write errors
      }
      return cookieValue;
    }
    return null;
  }

  static removeItem(key) {
    try {
      localStorage.removeItem(key);
    } catch (error) {
      // Ignore remove errors
    }
    try {
      removeStorageCookie(key);
    } catch (error) {
      // Ignore remove errors
    }
    return null;
  }

  static clear() {
    try {
      localStorage.clear();
    } catch (error) {
      // Ignore clear errors
    }
    try {
      clearStorageCookies();
    } catch (error) {
      // Ignore clear errors
    }
    return null;
  }

  static sync() {
    if (!Storage.syncPromise) {
      Storage.syncPromise = new Promise((res, rej) => {
        try {
          res();
        } catch (error) {
          rej(error);
        }
      });
    }
    return Storage.syncPromise;
  }
}

export default Storage;
